import { css } from '@emotion/react'
import styled from '@emotion/styled'

const baseStyles = ({ theme }) => css`
  label: share-button;

  button svg {
    label: share-button__icon;

    color: ${theme.colors.n600};
  }
`

export const ShareButton = styled('span')(baseStyles)
